export const drawingImgVariant = {
    initial:{
        opacity: 0,
        scale: 1.2
    },
    animate:{
        opacity: 1,
        scale: 1,
        transition:{
            duration: .5,
            delayChildren: 1,
            ease: "easeOut"
        }
    }
}